import { ReactNode } from 'react';
import { Dropdown, Loader } from 'semantic-ui-react';
import * as S from './styles';

interface KeyDownloadRowProps {
  title: string;
  hasDocument: boolean;
  isAdmin: boolean;
  isLoading?: boolean;
  uploadStatus?: 'idle' | 'loading' | 'success' | 'error';
  onClick?: () => void;
  getRootProps?: () => any;
  getInputProps?: () => any;
  menuItems?: ReactNode;
}

export default function KeyDownloadRow({
  title,
  hasDocument,
  isAdmin,
  isLoading = false,
  uploadStatus = 'idle',
  onClick,
  getRootProps,
  getInputProps,
  menuItems,
}: KeyDownloadRowProps) {
  const showUploadAffordance = isAdmin && !hasDocument;
  const isUploading = uploadStatus === 'loading';

  let state: string;
  if (isUploading) {
    state = 'UPLOADING_NEW';
  } else if (showUploadAffordance) {
    state = 'SELECTED_NO_DOC';
  } else {
    state = 'SELECTED_WITH_DOC';
  }

  const rowProps = showUploadAffordance && getRootProps ? getRootProps() : {};
  const rowClickProps = !showUploadAffordance && onClick ? { onClick } : {};

  return (
    <S.DocumentRowContainer>
      <S.DocumentRow {...rowProps} {...rowClickProps} state={state}>
        {getInputProps && <input {...getInputProps()} />}
        <S.DocumentRowTitle state={state}>
          {showUploadAffordance ? `${title} - upload here` : title}
        </S.DocumentRowTitle>
        <S.DocumentRowAlignRight>
          {showUploadAffordance && !isUploading && (
            <S.UploadIcon name="upload" style={{ color: 'var(--color-charcoal)' }} />
          )}
          {(isLoading || isUploading) && (
            <S.DocumentRowLoaderContainer>
              <Loader size="mini" active />
            </S.DocumentRowLoaderContainer>
          )}
          {!isLoading && !isUploading && !showUploadAffordance && menuItems && (
            <S.DocumentRowDropdown>
              <Dropdown.Menu style={{ transform: 'translateX(1rem)' }}>
                {menuItems}
              </Dropdown.Menu>
            </S.DocumentRowDropdown>
          )}
        </S.DocumentRowAlignRight>
      </S.DocumentRow>
    </S.DocumentRowContainer>
  );
}
